module.exports = __webpack_public_path__ + "img/couples-080.2d1bc7b4.jpg";